<template>
    <div>
        <vs-dialog width="550px" not-center v-model="active">
            <div class="con-content">
                <div>
                    <p class="mb-0">Alumno: <strong>{{row.nombre}}</strong></p>
                    <hr v-if="row.lenght > 1">
                    <div v-for="(info, i) in row.info" :key="i">
                        <p class="mb-0">Referencia: <strong>{{info.referencia}}</strong></p>
                        <p class="mb-0">Autorización: <strong>{{info.autorizacion}}</strong></p>
                        <p class="mb-0">Fecha: <strong>{{info.fecha_pago}}</strong></p>
                        <p class="mb-0">Monto: <strong>{{info.monto_total | currency}}</strong></p>
                    </div>
                </div>
            </div>

            <template #footer>
            <div class="con-footer" style="display: flex; justify-content: center;">
                <vs-button danger @click="active = false">
                Cancelar
                </vs-button>
                <vs-button success @click="getConciliar()">
                Aceptar
                </vs-button>
            </div>
            </template>
        </vs-dialog>
    </div>
</template>

<script>
import catalogos from '../../../../api/requests/catalogos.js'
export default {
    props:[
      'value',
      'row',
    ],
    data(){
        return{
            active: false
        }
    },
    methods:{
        async getConciliar(){
            const loading = this.$vs.loading()
            try{
                const params = {
                    persona_id: this.row.persona_id,
                    tip_id: this.row.info[0].tip_id
                }
                const response = await catalogos.getConciliar(params)
                this.$vs.notification({
                    progress: 'auto',                           
                    color: 'success',
                    position: null,
                    title: 'Operación éxitosa',
                    text: response.data.message
                })
                this.active = false
      		    this.$emit('refreshTable',true)
                loading.close()
            }catch(error){
                this.$vs.notification({
                    progress: 'auto',                           
                    color: 'danger',
                    position: null,
                    title: error.response.data.message
                })
                this.active = false
                loading.close()
            }
        }
    },
    watch: {
        value (val) {
            this.active = val
        },    
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>